import React, { useState, useEffect } from "react";
import { useGlobalContext } from "./../component/GlobalContext";
import { Bar } from "react-chartjs-2"; // Import the Bar chart component
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import AdminDashboard from "./Admin/AdminDashboard";
import VendorDashboard from "./Vendor/VendorDashboard";
import MemberDashboard from "./Member/MemberDashboard";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Dashboard() {
  const { globalUserVar,fetchCoupons,fetchVendors,fetchUsers} = useGlobalContext();
  const [roleId, setRoleId] = useState("");
  const [totalCoupons, setTotalCoupons] = useState(0);
  const [totalVendors, setTotalVendors] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeVendorsData, setActiveVendorsData] = useState({
    labels: [],
    datasets: [
      {
        label: 'Active Vendors',
        data: [],
        backgroundColor: 'rgba(75, 192, 192, 0.5)', // Set a background color for bars
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    let userData;
    if (typeof globalUserVar === "string") {
      userData = JSON.parse(globalUserVar); // Parse the JSON string
      setRoleId(userData.role_id);

      // loadCoupons();
      // loadVendors();
      // loadUsers();
    }
  }, [globalUserVar]);

  

  const renderComponent = () => {
    if (roleId == "1") {
      return <AdminDashboard />;
    }  else if (roleId == "2") {
      return <VendorDashboard />;
    }else if (roleId == "3") {
      return <MemberDashboard />;
    }else {
      return "";
    }
  };

  return (
    <>
      {renderComponent()}
    </>
  );
}

export default Dashboard;
